export default "__VITE_ASSET__STuiG5IV__"